import { useState } from 'react';
import { useGenericModal } from '..';
import { ConnectAspModal, ConnectAspModalProps } from './connect-asp-modal';

export const useConnectAspModal = (props?: Partial<ConnectAspModalProps>) => {
  const { modalRef, openModal, closeModal } = useGenericModal();

  const [modalType, setModalType] = useState<ConnectAspModalProps['type']>();

  const modalComponent = (
    <ConnectAspModal
      testId={props?.testId}
      modalRef={modalRef}
      onClose={closeModal}
      type={modalType}
    />
  );

  const openAspModal = (type?: ConnectAspModalProps['type']) => {
    setModalType(type);
    openModal();
  };

  return {
    modalRef,
    openModal: openAspModal,
    closeModal,
    connectAspModal: modalComponent,
  };
};
